import { VendorEnum } from '../vendors';

export type CertificateApiModel = {
  id: string;
  certificate_number: string;
  created_at: string;
  is_generated: boolean;
  student_course_id: string;
  template_vars: {
    course_title: string;
    first_name: string;
    last_name: string;
    vendor_slug: VendorEnum;
  };
};

export type CertificateApiResponseModel = {
  data: {
    certificate: CertificateApiModel;
  };
};

export type CertificatesApiResponseModel = {
  data: {
    certificates: CertificateApiModel[];
  };
};

export type CertificateModel = {
  id: string;
  certificateNumber: string;
  createdAt: string;
  studentCourseId: string;
  templateMeta: {
    courseTitle: string;
    firstName: string;
    lastName: string;
    vendorSlug: VendorEnum;
  };
};

export enum CertificateErrorStatusCodes {
  validationError = 422,
  conflict = 409,
}

export enum CertificateErrorTypes {
  alreadyCreated = 'ErrorCertificateHasAlreadyBeenCreated',
}

export type CertificateApiValidationErrors = Record<string, string[]>;
export type CertificateErrors = {
  data: {
    errors: CertificateApiValidationErrors;
  };
  status: CertificateErrorStatusCodes;
};
